export const GET_SOMETHING = 'GET_SOMETHING';
export const SET_SOMETHING = 'SET_SOMETHING';